<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2 id="label_SiteBlockSelectContractTitle">{{translate?.site.messages.selectExisting}} {{translate?.contracts.label.singular | lowercase}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" id="btn_SiteBlockSelectContractClose" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body mp-body">
        <form [formGroup]="selectContractForm">
            <div class="status-field">
                <label class="field-label mandatory" id="label_SiteBlockSelectContractFieldLabel">{{translate?.contracts.label.singular}}</label>
                <div class="field-row field-row--single">
                    <div>
                        <div class="p-inputgroup search">
                            <span class="p-input-icon-right w-100">
                                <p-autoComplete
                                    (onSelect)="gotSelectedContract($event)"
                                    id="picklist_SiteBlockSelectContractField"
                                    field="contractNumber"
                                    [suggestions]="contracts"
                                    (completeMethod)="getContractsFirstWay($event)"
                                    [placeholder]="translate?.general.commonComponent.messages.selectA +' ' + translate?.contracts.label.singular"
                                    name="contract"
                                    formControlName="contract"
                                    styleClass="w-100"
                                    [ngClass]="{'ng-invalid ng-dirty': selectContractForm.controls['contract'].touched && selectContractForm.controls['contract'].invalid}"
                                >
                                </p-autoComplete>
                                <i *ngIf="selectedContract" (click)="clearValue()" id="btn_SiteBlockSelectContractClear" class="p-autocomplete-clear-icon pi pi-times"></i>
                            </span>
                            <button type="button" pButton icon="fa-regular fa-magnifying-glass" [pTooltip]="translate?.contracts.label.singular+ ' Lookup'"
                                id="btn_SiteBlockSelectContractSearch" (click)="showTable()"></button>
                        </div>
                        <div class="p-error text-10" id="label_SiteBlockSelectContractError"
                            *ngIf="
                                (selectContractForm.controls['contract'].touched || selectContractForm.controls['contract'].dirty) &&
                                selectContractForm.controls['contract'].invalid
                            ">
                            <span *ngIf="selectContractForm.controls['contract'].errors?.required" id="label_SiteBlockSelectContractRequiredError">{{translate?.general.validationFE.requiredField}}</span>
                        </div>

                    </div>
                    <footer *ngIf="displayTable" class="custella-form-container-footer hidePopup">
                        <p-dialog [header]="translate?.contracts.sections.sec1.singular" id="title_ContractDet" [(visible)]="displayTable" showEffect="fade" [style]="{ width: '70vw' }" [modal]="true" [draggable]="false">
                            <app-custella-contracts [customerId]="data.customerId" (itemSelector)="gotSelectedContract($event)" (closeView)="closeContractView()"></app-custella-contracts>
                        </p-dialog>
                    </footer>
                </div>
            </div>
        </form>
    </div>

    <div class="flx-modal__footer">
        <p-button type="button" (onClick)="onUseThisContract()" id="btn_SiteBlockSelectContractUseThis" [label]="translate?.site.messages.useThis + ' ' + translate?.contracts.label.singular" styleClass="h-32 dark"></p-button>
        <p-button type="button" styleClass="h-32" id="btn_SiteBlockSelectContractCreate" [label]="translate?.general.buttons.create.singular + ' ' + translate?.contracts.label.singular" icon="fa-regular fa-plus" (onClick)="onCreateContract()"></p-button>
        <button class="custella-btn-white" id="btn_SiteBlockSelectContractCancel" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
    </div>
</div>